var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00488 9.49951V3.99951C2.00488 3.44723 2.4526 2.99951 3.00488 2.99951H21.0049C21.5572 2.99951 22.0049 3.44723 22.0049 3.99951V9.49951C20.6242 9.49951 19.5049 10.6188 19.5049 11.9995C19.5049 13.3802 20.6242 14.4995 22.0049 14.4995V19.9995C22.0049 20.5518 21.5572 20.9995 21.0049 20.9995H3.00488C2.4526 20.9995 2.00488 20.5518 2.00488 19.9995V14.4995C3.38559 14.4995 4.50488 13.3802 4.50488 11.9995C4.50488 10.6188 3.38559 9.49951 2.00488 9.49951ZM9.00488 8.99951V10.9995H15.0049V8.99951H9.00488ZM9.00488 12.9995V14.9995H15.0049V12.9995H9.00488Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.0cc4d985f85a4977468a77887bb5a9a5.svg";
export { ForwardRef as ReactComponent };